// extracted by mini-css-extract-plugin
export default {"item":"AppItem_item__cnOPJ","logo":"AppItem_logo__AwyTU","info":"AppItem_info__oKa95","title":"AppItem_title__IVR8A","desc":"AppItem_desc__-yhHi","selItem":"AppItem_selItem__rmETF"};